module.exports = __webpack_public_path__ + "img/loginBg.49c8af93.png";